<template>
  <div>
    <div ref="user_selector">
      <BaseSelectorField
        v-model="query_params.search"
        displayName="full_name"
        :multiple="multiple"
        :selectedItems="selectedItems"
        :objectName="multiple ? null : selectedItems[0]?.full_name"
        :placeholder="disabled ? null : `Select ${!multiple ? modelName.singular : modelName.plural}`"
        :inputClasses="inputClasses"
        :label="label"
        :disabled="disabled"
        :validation="validation"
        :hasWarning="hasWarning"
        :warningMessage="warningMessage"
        :hideMessage="hideMessage"
        :loading="loading || addLoading"
        :searching="searching"
        :required="required"
        :isVoid="isVoid"
        @open-dialog="openModal"
        @clear-selection="clearSelection"
        @focus="handleFieldFocus"
        @blur="handleFieldBlur"
        @query="query"
        @remove-item="removeItem"
        tabindex="1"
      />

      <BaseDialogSelectorList
        displayName="full_name"
        matchKey="id"
        :open="listVisible"
        :items="query_data?.results"
        :target="$refs.user_selector"
        :searching="searching"
        :selectedItems="selectedItems"
        :modelName="modelName"
        :enableNew="false"
        @selected="selectItem"
        @create="create"
        @clear="clearSelection"
        @update:open="listVisible = $event"
      />
    </div>

    <BaseSelectorDialog 
      v-model="query_params.search" 
      ref="dialog" 
      :modelName="modelName" 
      :loading="addLoading"
      @openNew="openNew"
      @open="dialogOpen = true"
      @close="dialogOpen = false"
      disableQuickAdd
    >
      <template #filters>
        <slot name="filters">
          <!-- <BaseUserGroupDialogSelector v-model="query_params.user_group" disableAdd disableModals disableQuickAdd /> -->
        </slot>
      </template>

      <template #table>
        <BaseTable
          ref="table"
          :selectMode="multiple ? 'multi' : 'single'"
          :data_="query_data"
          :fields="fields"
          :selected.sync="selectedItems"
          :defaultPageSize="query_params.page_size"
          :modelName="modelName"
          :loading="queryLoading"
          @page_change="query_params.page = $event"
          @page_size_change="query_params.page_size = $event"
          @ordering_change="query_params.ordering = $event"
          @selected="() => { if (!multiple) $refs.dialog.hide() }"
          :rowClickable="!multiple"
        />
      </template>
    </BaseSelectorDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import BaseDialogSelector from "@/components/shared/BaseDialogSelectors/BaseDialogSelector.vue";
// import BaseUserGroupDialogSelector from "@/components/shared/BaseDialogSelectors/BaseUserGroupDialogSelector.vue";

export default {
  extends: BaseDialogSelector,
  components: {
    // BaseUserGroupDialogSelector,
  },
  props: {
    label: { type: String, default: "User", },
    users: { type: Array, description: "", default(rawProps) { return null; }, },
  },
  data() {
    return {
      fields: [
        { key: "first_name", sortable: true },
        { key: "last_name", sortable: true },
        { key: "user_group.name", label: "User Group" },
      ],
      modelName: { singular: "User", plural: "Users" },
    };
  },
  methods: {
    ...mapActions("users", ["fetchUsers"]),

    openNew() {
      const url = this.$router.resolve("/settings/users/").href;
      window.open(url, "_blank");
    },

    query() {
      this.queryLoading = true;
      this.searching = true;
      this.fetchUsers({
          ...this.query_params,
          users: this.users,
      }).then((res) => {
          this.query_data = res.data;
      }).finally(() => {
        this.queryLoading = false;
        this.searching = false;
      });
    },
  },
};
</script>